var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form-item',{staticClass:"phoneInput"},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
      'phoneNumber',
      {
        rules: [
          {
            validator: _vm.checkPhoneNumberOrEmail,
          } ],
        normalize: function(value) {
          return value ? value.trim() : value;
        },
      } ]),expression:"[\n      'phoneNumber',\n      {\n        rules: [\n          {\n            validator: checkPhoneNumberOrEmail,\n          },\n        ],\n        normalize: function(value) {\n          return value ? value.trim() : value;\n        },\n      },\n    ]"}],ref:"input",attrs:{"placeholder":_vm.placeholder || _vm.$t('user.login.name.placeholder')}},[_c('icon-font',{attrs:{"slot":"prefix","type":"mobile"},slot:"prefix"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }